// <count-down>: fixed (hides when expired) or evergreen (rolling localStorage
// deadline, keyed per block) — ticks 1s into [data-hh]/[data-mm]/[data-ss].
customElements.define(
  "count-down",
  class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode === "fixed") {
        this.deadline = Date.parse(this.dataset.end);
        if (!this.deadline || this.deadline <= Date.now()) { this.hidden = true; return; }
      } else {
        this.key = "jg-cd-" + this.dataset.key;
        this.duration = (parseFloat(this.dataset.hours) || 24) * 3600 * 1000;
        let ts = 0;
        try { ts = parseInt(localStorage.getItem(this.key), 10) || 0; } catch {}
        if (!ts || ts <= Date.now()) {
          ts = Date.now() + this.duration;
          try { localStorage.setItem(this.key, String(ts)); } catch {}
        }
        this.deadline = ts;
      }
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      let remaining = this.deadline - Date.now();
      if (remaining <= 0) {
        if (this.dataset.mode === "fixed") { this.hidden = true; clearInterval(this.timer); return; }
        this.deadline = Date.now() + this.duration;
        try { localStorage.setItem(this.key, String(this.deadline)); } catch {}
        remaining = this.duration;
      }
      const total = Math.floor(remaining / 1000);
      const pad = (n) => String(n).padStart(2, "0");
      const set = (sel, v) => {
        const el = this.querySelector(sel);
        if (el && el.textContent !== v) el.textContent = v;
      };
      set("[data-hh]", pad(Math.floor(total / 3600)));
      set("[data-mm]", pad(Math.floor((total % 3600) / 60)));
      set("[data-ss]", pad(total % 60));
    }
  }
);
